//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TextWithIcon from '../other/TextWithIcon'
export default {
  components: {
    TextWithIcon
  },
  props: {
    content: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isEn() {
      return this.$i18n.locale === 'en'
    },
    queryLang() {
      return this.isEn ? '?lang=en' : ''
    }
  },
  /*
  mounted() {
    setTimeout(() => {
      if (this.$route.query.hasOwnProperty('ignoreBanner')) {
        // this.$router.push(`${this.$route.path}#news-start`)
        const target = document.getElementById('news')
        if (target) {
          window.scrollTo(0, target.offsetTop + 200);
        }
      }
    }, 1500)
  },
  */
  methods: {
    pictureUrl (url) {
      return this.$absoluteImageUrl(url)
    }
  }
}
